import AdminDashboardScreen from './AdminDashboardScreenContainer';
export default AdminDashboardScreen;
